// #region Dependencias
import {
  flexRender,
  getCoreRowModel,
  useReactTable
} from '@tanstack/react-table'
import styled from 'styled-components'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledTableContainer = styled.div`
  margin: 1rem 0;
  overflow-x: auto;
`
const StyledTable = styled.table`
  width: 100%;
`
const StyledTableHead = styled.thead``
const StyledTableRow = styled.tr``
const StyledTableHeader = styled.th`
  border-bottom: 1px solid ${colors.light};
  font-weight: bold;
  height: 1.5rem;
  padding: 0 0.5rem;
`
const StyledTableBody = styled.tbody``
const StyledTableCell = styled.td`
  border-bottom: 1px solid ${colors.light};
  height: 1.5rem;
  padding: 0.25rem;
  text-align: center;
`
// #endregion

/**
 * Componente para renderizar una tabla con columnas y datos personalizados
 * usando la librería de tanstack/react-table
 *
 * @class
 * @example
 * const columns = [{
 *  accessorFn: (row) => row.code,
 *  id: "code",
 *  header: "Código",
 *  cell: (row) => row.getValue(),
 * }];
 *
 * const data = [{
 *  id: 1
 * }];
 *
 * return (
 *  <Table columns={columns} data={data} />
 * )
 *
 * @param {Object[]} columns - Arreglo de columnas de la tabla.
 * @param {Object[]} data - Arreglo de datos de la tabla.
 * @param {Object} props - Propiedades del componente.
 */
const Table = ({ columns, data, ...props }) => {
  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel()
  })

  return (
    <StyledTableContainer>
      <StyledTable {...props}>
        <StyledTableHead>
          {table.getHeaderGroups().map((headerGroup) => (
            <StyledTableRow key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <StyledTableHeader key={header.id}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                </StyledTableHeader>
              ))}
            </StyledTableRow>
          ))}
        </StyledTableHead>
        <StyledTableBody>
          {table.getRowModel().rows.map((row) => (
            <StyledTableRow key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <StyledTableCell key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledTableContainer>
  )
}

export default Table
